import React, {useState, useLayoutEffect} from 'react';
import {has, clamp} from 'helpers';
import css from './progress.module.scss';

export function Progress({ className, ...props }) {
  const [ mounted, setMounted ] = useState();
  const Inner = props.semicircle ? SemiCircle : Circle;
  const ratio = props.total ? clamp(props.completed / props.total, 0, 1) : 0;

  useLayoutEffect(() => {
    setMounted(true);
  }, []);

  return (
    <span className={css('container', className, { mounted })}>
      <Inner ratio={ratio} />
      { props.children }
      { (props.total || has(props, 'label')) && !props.children &&
        <label className={css.label}>
          { has(props, 'label') ? props.label : (Math.round(ratio*100)+'%') }
        </label>
      }
    </span>
  );
}

function Circle({ ratio }) {
  const radius = 45;
  const length = radius*2*Math.PI
  return (
    <svg viewBox="0 0 100 100" className={css.circleContainer}>
      <circle cx="50" cy="50" r={radius} className={css.back} />
      <circle cx="50" cy="50" r={radius} className={css.front} strokeDasharray={length} strokeDashoffset={(1-ratio)*length} />
    </svg>
  );
}

function SemiCircle({ ratio }) {
  const d = "M7.234 60A43.498 43.498 0 016 49.685C6 25.56 25.7 6 50 6h0a44.034 44.034 0 0139.1 23.632A43.247 43.247 0 0194 49.685c0 3.554-.427 7.008-1.234 10.315";
  const length = 158.5818;
  return (
    <svg viewBox="0 0 100 100">
      <path d={d} className={css.back} />
      <path d={d} className={css.front} strokeDasharray={length} strokeDashoffset={(1-ratio)*length} />
    </svg>
  );
}
